var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgPlateDeep = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70,0H30A30,30,0,0,0,0,30V70a30,30,0,0,0,30,30H70a30,30,0,0,0,30-30V30A30,30,0,0,0,70,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    d: "M37.4,30.264a1.115,1.115,0,0,0-.518.867,2.225,2.225,0,0,0,.1,1.382,2.029,2.029,0,0,0,.76.824,8.369,8.369,0,0,0,2.381.917l.4.11a1,1,0,0,1-.545,1.924l-.336-.092a10.413,10.413,0,0,1-3-1.192,4.016,4.016,0,0,1-1.47-1.651,4.2,4.2,0,0,1-.252-2.592,3.09,3.09,0,0,1,1.553-2.268,3.032,3.032,0,0,1,2.342-.166,2.953,2.953,0,0,1,1.756,1.467,2.567,2.567,0,0,1-.228,2.576,1,1,0,0,1-1.68-1.085c.211-.326.162-.51.11-.616a.967.967,0,0,0-.576-.441A1.037,1.037,0,0,0,37.4,30.264Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    d: "M50,36a2,2,0,1,1-2-2A2,2,0,0,1,50,36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    d: "M54,41a1,1,0,1,0-1-1A1,1,0,0,0,54,41Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    d: "M36,44a1,1,0,1,1-1-1A1,1,0,0,1,36,44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    fillRule: "evenodd",
    d: "M68.241,57.682,89.172,52.07a3,3,0,1,0-1.554-5.8l-21.2,5.684-.049.012L25.8,62.848a1,1,0,0,0-.707,1.225A19,19,0,0,0,48.364,77.506l5.8-1.554a19,19,0,0,0,14.081-18.27Zm-.1-2.044,20.514-5.5a1,1,0,0,0-.518-1.932L67.827,53.651A19.02,19.02,0,0,1,68.14,55.638Zm-33.2,18.24a17,17,0,0,1-7.636-9.364L65.891,54.169A17,17,0,0,1,53.642,74.02l-5.8,1.554A17,17,0,0,1,34.944,73.877Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    fillRule: "evenodd",
    d: "M57.927,44.824a1,1,0,0,1,.716.293l4.573,4.573a1,1,0,0,1-.013,1.427,4.234,4.234,0,0,1-5.987-5.987A1,1,0,0,1,57.927,44.824Zm.2,2.6a2.234,2.234,0,0,0,2.784,2.784Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    d: "M41.859,47.869a1,1,0,0,0-2,0,4.805,4.805,0,0,0,.543,2.425,4.675,4.675,0,0,0,1.1,1.258l.025.022a2.892,2.892,0,0,1,.7.746,2.781,2.781,0,0,1,.283,1.419,1,1,0,1,0,2,0,4.735,4.735,0,0,0-.546-2.409,4.684,4.684,0,0,0-1.094-1.241l-.033-.028a2.287,2.287,0,0,1-.98-2.191Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    d: "M44.849,45.377a1,1,0,0,0-2,0,4.8,4.8,0,0,0,.544,2.425,4.673,4.673,0,0,0,1.1,1.258l.025.022a2.893,2.893,0,0,1,.7.746,2.782,2.782,0,0,1,.283,1.419,1,1,0,0,0,2,0,4.733,4.733,0,0,0-.546-2.409A4.682,4.682,0,0,0,45.862,47.6l-.033-.028a2.288,2.288,0,0,1-.98-2.191Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#69707f",
    d: "M46.84,42.382a1,1,0,0,1,1,1,2.287,2.287,0,0,0,.98,2.191l.033.028a4.684,4.684,0,0,1,1.094,1.241,4.735,4.735,0,0,1,.546,2.409,1,1,0,0,1-2,0,2.781,2.781,0,0,0-.283-1.419,2.894,2.894,0,0,0-.7-.746l-.025-.022a4.675,4.675,0,0,1-1.1-1.258,4.805,4.805,0,0,1-.543-2.425A1,1,0,0,1,46.84,42.382Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlateDeep, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plate-deep.94816612.svg";
export { ForwardRef as ReactComponent };